var Links = {
  deleteLink: function (a) {
    if (confirm("Eliminar?")) {
      AJAX.ajaxInsert("fun/actions", "deleteLink&id=" + a, "", "sec/listarLinks.php", ".data")
    } else {return false}
  }
};

// Shadowbox.init();